import { FunctionComponent } from "react";

import useTypedContext from "hooks/useTypedContext";
import Box from "ds/components/Box";
import IconEmphasized from "ds/components/IconEmphasized";
import TileTitle from "ds/components/Tile/Title";
import TileDescription from "ds/components/Tile/Description";
import TileWrapperButton from "ds/components/Tile/Wrapper/Button";

import { ModuleFormContext } from "../context";
import { ModuleCreationWizardStep } from "../types";

type NewModuleIntermediateConfirmationStepTileProps = {
  icon: FunctionComponent;
  title: string;
  description: string;
  action: {
    step: ModuleCreationWizardStep;
    title: string;
  };
};

const NewModuleIntermediateConfirmationStepTile = ({
  icon: Icon,
  title,
  description,
  action,
}: NewModuleIntermediateConfirmationStepTileProps) => {
  const { setCurrentStep, setIsIntermediateStepActive } = useTypedContext(ModuleFormContext);
  const actionHandler = () => {
    setIsIntermediateStepActive(false);
    setCurrentStep(action.step);
  };

  return (
    <TileWrapperButton onClick={actionHandler}>
      <Box align="start" justify="between" fullWidth>
        <Box align="center" grow="1" gap="medium">
          <IconEmphasized icon={Icon} />

          <Box direction="column" gap="small">
            <TileTitle>{title}</TileTitle>
            <TileDescription>{description}</TileDescription>
          </Box>
        </Box>
      </Box>
    </TileWrapperButton>
  );
};

export default NewModuleIntermediateConfirmationStepTile;
